import { registerPlugin } from '@capacitor/core';

/**
 * Lightweight bridge to the native NotificationAction plugin:
 * - fetches the last notification action for cold start
 * - subscribes to live notification action events
 *
 * Kept minimal: only exposes the methods we use in NotificationHandler.
 */
type NotificationAction = {
  actionId?: string;
  type?: string;
  tenantIds?: string;
  tenantCount?: string;
  totalAmount?: string;
  taskName?: string;
};

type ActionListener = (action: NotificationAction) => void;

type PluginMethods = {
  getLastAction: () => Promise<NotificationAction>;
  addListener: (event: 'action', listener: ActionListener) => { remove: () => void };
};

const NotificationActionPlugin = registerPlugin<PluginMethods>('NotificationAction');

export async function getLastNotificationAction(): Promise<NotificationAction | null> {
  try {
    const result = await NotificationActionPlugin.getLastAction();
    if (!result || Object.keys(result).length === 0) {
      return null;
    }
    return result;
  } catch (_error) {
    return null;
  }
}

export function addNotificationActionListener(listener: ActionListener) {
  return NotificationActionPlugin.addListener('action', listener);
}
